import {GetCharacterMeta} from '@/graphql/queries/Character.graphql'
import {UpdateCharacterMeta} from '@/graphql/mutations/Character.graphql'

export default {
  data(){
    return {
      characterMetaData : {}
    };
  },

  apollo : {
    characterMetaList : {
      query : GetCharacterMeta
    }
  },

  watch : {
    characterMetaList : {
      handler(data){
        if(typeof data.data === 'undefined') return;

        this.characterMetaData = JSON.parse(data.data);
      }
    }
  },

  methods  : {
    updateCharacterMeta(updateData){
      const updateDataText = JSON.stringify(updateData);

      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : UpdateCharacterMeta,
          variables : {
            data  : updateDataText
          },
          update    : (store, {data: {characterMetaList}}) => {
            const parameters = {
              query : GetCharacterMeta,
            };

            const readData = store.readQuery(parameters);

            readData.characterMetaList = characterMetaList;

            parameters.data = readData;

            store.writeQuery(parameters);
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    }
  }
}